<template>
  <div>
    <a-modal
      title="待联系订单"
      width="1400px"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-row :gutter="24">
        <a-col :md="6" :sm="24">
          <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="queryParam.enterpriseName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="客户姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="queryParam.customerName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="queryParam.customerMobile"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="queryParam.orderNo" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="end">
        <a-col style="margin-right: 40px" :style="{ textAlign: 'right' }">
          <!--  查询功能待完善 只能查询公司名-->
          <a-button type="primary" htmlType="submit" @click="getdataList1(1)">查询</a-button>
          <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
          <a-divider />
          <a-table
            size="small"
            ref="table"
            rowKey="orderId"
            :columns="columns"
            :dataSource="loadData"
            :pagination="false"
            :scroll="{ x: 2600 }"
            bordered
            :loading="loading"
            :row-selection="rowSelection"
            :rowClassName="setClassName"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="ProcessedClick(record)">处理完成</a>
              <a-divider type="vertical" />
              <a @click="editorder(record)">编辑</a>
            </span>
            <span slot="appointmentTime" slot-scope="text, record">
              {{ record.appointmentTime + ' ' + record.timeQuantum + '点' }}
            </span>
          </a-table>
          <a-pagination
            showQuickJumper="true"
            showSizeChanger
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @showSizeChange="onShowSizeChange"
            :total="total"
            v-model="current"
            @change="getdataList1"
            :showTotal="(total) => `总共 ${total} 条`"
            style="text-align: right; margin-top: 20px"
          />
        </a-col>
      </a-row>
      <template slot="footer">
        <div style="text-align: center">
          <a-button key="submit" type="primary" :loading="loading" @click="handleOk"> 确认 </a-button>
          <a-button key="back" @click="handleCancel"> 取消 </a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getStayOrder, updateOrderJobRemind } from '@/api/order/orderList'
export default {
  props: [],
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      //   loading: true,
      loadData: [],
      current: 1,
      pageSize: 10,
      queryParam: {
        remindType: 0,
        status: 0,
      },
      // 列表
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center',
          customRender: (text, record, index) => `${(this.current - 1) * this.pageSize + (index + 1)}`,
        },
        {
          title: '操作',
          // width: '270px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installTypeName',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },

        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerName' },
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'customerMobile',
          //   className: checkPermission('order:list:detail:detailTab:clientNo:show') ? '' : 'notshow',
          scopedSlots: { customRender: 'customerMobile' },
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'detailedAddress',
          // header-align:"center",
          scopedSlots: { customRender: 'detailedAddress' },
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          //   className: checkPermission('order:list:detail:detailTab:masterInfo:name') ? '' : 'notshow',
          scopedSlots: { customRender: 'masterName' },
          align: 'center',
        },
        {
          title: '师傅联系方式',
          //   className: checkPermission('order:list:detail:detailTab:masteInfo:phoneNo:all') ? '' : 'notshow',
          scopedSlots: { customRender: 'masterPhone' },
          dataIndex: 'masterPhone',
          align: 'center',
        },
        {
          title: '预约上门时间',
          dataIndex: 'appointmentTime',
          scopedSlots: { customRender: 'appointmentTime' },
          align: 'center',
        },
      ],
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
    }
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    showModal() {
      this.visible = true
      this.getdataList1(1)
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    editorder(record) {
      this.visible = false
      this.$emit('ok2', record)
    },
    // 高亮显示
    setClassName(record) {
      if (record.isToday == '1') {
        // 超时订单
        return 'clickRowStyle'
      }
    },
    handleCancel(e) {
      console.log('Clicked cancel button')
      this.visible = false
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },
    ProcessedClick(record) {
      updateOrderJobRemind({
        remindId: record.remindId,
        status: 0,
        isToday: record.isToday,
        orderId: record.orderId,
        orderNo: record.orderNo,
        orderStatus: record.orderStatus,
        remindType: 1,
      }).then((res) => {
        if (res.code === 0) {
          this.getdataList1(1)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    empty() {
      this.queryParam = {
        remindType: 0,
        status: 0,
      }
    },
    getdataList1(value) {
      this.current = value
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.queryParam.isAuthority = 1 //  数据隔离
      getStayOrder(this.queryParam).then((res) => {
        if (res.code === 0) {
          this.loadData = res.rows
          this.total = res.total
          // this.$emit('ok3', 0)
          for (var i = 0; i < this.loadData.length; i++) {
            if (this.loadData[i].appointmentTime) {
              var list = this.loadData[i].appointmentTime.split(' ')
              this.loadData[i].appointmentTime = list[0]
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped >
/deep/ .clickRowStyle {
  background: #ffbcb7;
}
</style>
